import * as React from 'react';
import { ContainerType } from 'types/Shipping';

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { ReactComponent as ContainerIcon } from '../../assets/andora-icons/container.svg';

interface Props {
  containerTypes: ContainerType[];
  selectedContainerTypeKey: string;
  setContainerType: (key: string) => void;
}

export const ContainerTypeDropdown: React.FC<Props> = (props) => {
  const { containerTypes, selectedContainerTypeKey, setContainerType } = props;
  return (
    <div className="flex flex-col space-y-2">
      <div className="flex space-x-2 items-center">
        <ContainerIcon className="w-4 h-4" />
        <h4 className="text-dark font-medium">Container Type</h4>
      </div>
      <FormControl sx={{ minWidth: 350 }}>
        <Select
          displayEmpty
          onChange={(event) => {
            setContainerType(event.target.value);
          }}
          value={selectedContainerTypeKey}
        >
          {!selectedContainerTypeKey && (
            <MenuItem value="" disabled>
              <p className="text-gray-700">Select a container type</p>
            </MenuItem>
          )}
          {containerTypes.map((listRow) => (
            <MenuItem key={listRow.key} value={listRow.key}>
              {listRow.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};
